import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface PeaksProgressResponse {
  fast_phonics_progress: {
    summary: SummaryData
    students: StudentData[]
  }
}

interface SummaryData {
  lessons: {
    lessons_completed: number
    student_average: number
  }
  book_quizzes: {
    books_read: number
    student_average: number
  }
  lesson_quizzes: {
    total_score: number
    student_average: number
  }
  sound_gems: {
    sound_gems_earned: number
    student_average: number
  }
  word_gems: {
    word_gems_earned: number
    student_average: number
  }
}

interface StudentData {
  student_id: number
  average_score: number
  lessons_completed: number
  books_read: number
  sound_gems_earned: number
  word_gems_earned: number
}

export interface PeaksProgressData {
  summary: SummaryData
  students: StudentData[]
}

export async function peaksProgress(
  this: StudentEventsService,
  product: LegacyProductFp,
  statsScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<PeaksProgressData>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('progress', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<PeaksProgressResponse>(url, query)
  if (!data) return null

  const { fast_phonics_progress } = data
  if (fast_phonics_progress.students.length === 0) return null

  return fast_phonics_progress
}
